












import Vue from 'vue'
import style from './style.module.scss'

import buttonRed from '@/components/common/click/button/button-red.vue'

export default Vue.extend({
    name: 'error',
    components: {
        buttonRed
    },
    props: {
        errorMessage: {
            type: String
        }
    },
    data() {
        return {
            style: style
        }
    }
})
